// lib/onboarding.ts
export const ONBOARDING_REMINDER_KEY = 'onboarding_remind_later_until'
export const ONBOARDING_REMINDER_DURATION_MS = 24 * 60 * 60 * 1000

export const clearOnboardingReminder = (): void => {
  try {
    localStorage.removeItem(ONBOARDING_REMINDER_KEY)
  } catch (err) {
    console.error('Failed to clear onboarding reminder:', err)
  }
}

export const isOnboardingReminderActive = (): boolean => {
  try {
    const remindUntil = localStorage.getItem(ONBOARDING_REMINDER_KEY)
    return !!remindUntil && Date.now() < Number(remindUntil)
  } catch (err) {
    console.error('Failed to read onboarding reminder:', err)
    return false
  }
}